/* eslint-disable @typescript-eslint/no-use-before-define */

import {
  Video,
  VideoRight
} from '../types';

export function isVideoLockedForUser(
  video: Video,
  isUserPremium: boolean,
  userEntitlements: number[]
): boolean {
  const userHasDigitalCopyRights = hasDigitalCopyRights(video, userEntitlements);
  const userHasAVODRights = hasAVODRights(video.videoRights);
  const userHasSVODRights = hasSVODRights(video.videoRights, isUserPremium);
  
  return !userHasDigitalCopyRights && !userHasAVODRights && !userHasSVODRights;
}

function hasDigitalCopyRights(video: Video, userEntitlements: number[]): boolean {
  const userHasEntitlement = userEntitlements.includes(video.id);
  if (!userHasEntitlement) {
    // No Entitlements to check
    return false;
  }

  const videoRights = video.videoRights;
  const currentDateTime = (new Date().getTime());

  const isValidDigitalCopy = videoRights.some((videoRight) => {
    const isWithinTimeFrame = currentDateTime >= videoRight.startDate && currentDateTime <= videoRight.endDate;
    const isDigitalCopyRight = videoRight.right.name.toLowerCase() === 'est';

    return isWithinTimeFrame && isDigitalCopyRight;
  });

  return isValidDigitalCopy;
}

function hasAVODRights(videoRights: VideoRight[]): boolean {
  const currentDateTime = (new Date().getTime());

  const canWatchVideo = videoRights.some((videoRight) => {
    const isWithinTimeFrame = currentDateTime >= videoRight.startDate && currentDateTime <= videoRight.endDate;
    const isAVOD = videoRight.right.name.toLowerCase() === 'avod';

    return isWithinTimeFrame && isAVOD;
  });

  return canWatchVideo;
}

function hasSVODRights(videoRights: VideoRight[], isUserPremium: boolean): boolean {
  const currentDateTime = (new Date().getTime());

  const canWatchVideo = videoRights.some((videoRight) => {
    const isWithinTimeFrame = currentDateTime >= videoRight.startDate && currentDateTime <= videoRight.endDate;
    const isAllowedAccess = isUserPremium && videoRight.right.name.toLowerCase() === 'svod';
  
    return isWithinTimeFrame && isAllowedAccess;
  });

  return canWatchVideo;
}
